import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { isEmpty } from 'lodash';
import { ProfileService } from '../profile.service';
import { Subscription } from 'rxjs'; // Import Subscription
import { ToastrService } from 'ngx-toastr';
import * as Highcharts from 'highcharts';
import { CommonService } from 'src/app/services/common-services/common.service';
import HC_more from 'highcharts/highcharts-more';
HC_more(Highcharts);

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent {
  startSub: Subscription | undefined;
  endSub: Subscription | undefined;

  barChartRFQ: typeof Highcharts = Highcharts;
  barChartOptions!: Highcharts.Options;

  barChartOMS: typeof Highcharts = Highcharts;
  barChartOMSOptions!: Highcharts.Options;

  barChartQuotes: typeof Highcharts = Highcharts;
  barChartQuotesOptions!: Highcharts.Options;

  pieChart: typeof Highcharts = Highcharts;
  pieChartOptions!: Highcharts.Options;

  //rfq buttons
  totalRFQ: number = 0; // will be calculated
  totalInProgressRFQ: number = 0;
  totalAcceptedRFQ: number = 0;
  totalReturnedRFQ: number = 0;
  monthRFQ: any[] = []; // will store months provided in API
  totalRFQData: any[] = []; //array to store totals
  returnedRFQData: any[] = []; // array to store all returned rfq
  inProgressRFQData: any[] = []; // array to store in progress rfq data
  acceptedRFQData: any[] = []; // array to store all acceptedv RFQ data
  //oms buttons
  totalOMS: number = 0;
  totalInProgressOMS: number = 0;
  totaldeliveredOMS: number = 0;
  totaldelayedOMS: number = 0;
  totalOMSData: any[] = []; //array to store totals
  delayedOMSData: any[] = []; // array to store all delayed OMS
  inProgressOMSData: any[] = []; // array to store in progress oms data
  deliveredOMSData: any[] = []; // array to store all delivered oms data

  //financial buttons
  totalPayments: number = 200;
  advancePayments: number = 80;
  overduePayments: number = 60;
  completedPayments: number = 90;

  //profile Updates
  profileCompleted: number = 0;
  profilePending: number = 0;

  //quotes button
  totalQuotesReceived: number = 0;
  totalQuotesAccepted: number = 0;
  totalQuotesRejected: number = 0;
  totalQuotesUnderRevision: number = 0;
  totalQuotesReceivedData: any[] = [];
  totalQuotesAcceptedData: any[] = [];
  totalQuotesRejectedData: any[] = [];
  totalQuotesUnderRevisionData: any[] = [];

  customerUserName: string | null = '';
  customerCompanyId?: any;
  customerUserId?: any;
  range = new FormGroup({
    start: new FormControl<Date | null>(null, Validators.required),
    end: new FormControl<Date | null>(null, Validators.required),
  });
  constructor(
    private toastr: ToastrService,
    private router: Router,
    private profileService: ProfileService,
    private commonService: CommonService,
  ) {}
  ngOnInit() {
    this.customerUserName = this.commonService.getUserName();

    this.commonService.sharedData$.subscribe({
      next: (userName: string) => {
        this.customerUserName = userName;
      },
      error: (err) => {
        console.error('Error in subscription:', err);
      },
    });
    this.customerCompanyId = localStorage.getItem('customercompanyId');
    this.customerUserId = localStorage.getItem('customeruserId');
    const today = new Date();

    const sixMonthsBack = new Date();
    sixMonthsBack.setMonth(today.getMonth() - 5);
    this.range.patchValue({
      start: sixMonthsBack,
      end: today,
    });

    this.initRFQBarChart();
    this.initOMSBarChart();
    this.initQuotesBarChart();
    this.initProfilePieChart();

    if (this.range.value.start && this.range.value.end) {
      this.getGraphData(
        this.range.value.start,
        this.range.value.end,
        this.customerCompanyId,
        this.customerUserId,
      );
    } else {
      this.getGraphData(null, null, this.customerCompanyId, this.customerUserId);
    }
    //for start and end dates
    this.startSub = this.range.get('start')?.valueChanges.subscribe((value) => {
      if (value && this.range.value.end) {
        // Add null check
        this.onStartDateChange(value);
      }
    });

    // Subscribe to end date changes
    this.endSub = this.range.get('end')?.valueChanges.subscribe((value) => {
      if (value && this.range.value.start) {
        // Add null check
        this.onEndDateChange(value);
      }
    });
  }
  clearDate() {
    this.startSub?.unsubscribe();
    this.endSub?.unsubscribe();

    // Reset the form values
    this.range.setValue({
      start: null,
      end: null,
    });

    // Call getGraphData with null values
    this.getGraphData(null, null, this.customerCompanyId, this.customerUserId);

    // Re-subscribe after resetting the dates
    this.startSub = this.range.get('start')?.valueChanges.subscribe((value) => {
      if (value && this.range.value.end) {
        this.onStartDateChange(value);
      }
    });

    this.endSub = this.range.get('end')?.valueChanges.subscribe((value) => {
      if (value && this.range.value.start) {
        this.onEndDateChange(value);
      }
    });
  }
  onStartDateChange(value: any) {
    this.range.value.start = value;
    if (this.range.value.start && this.range.value.end) {
      this.getGraphData(
        this.range.value.start,
        this.range.value.end,
        this.customerCompanyId,
        this.customerUserId,
      );
    }
  }
  onEndDateChange(value: any) {
    this.range.value.end = value;
    if (this.range.value.start && this.range.value.end) {
      this.getGraphData(
        this.range.value.start,
        this.range.value.end,
        this.customerCompanyId,
        this.customerUserId,
      );
    }
  }

  getGraphData(
    startDate: any,
    endDate: any,
    customerCompanyId: any,
    customerUserId: any,
  ) {
    if (startDate != null && endDate != null) {
      this.profileService
        .requestDataForGraphs(startDate, endDate, customerCompanyId, customerUserId)
        .subscribe({
          next: (responseList: any) => {
            this.monthRFQ = [];
            this.inProgressRFQData = [];
            this.acceptedRFQData = [];
            this.returnedRFQData = [];
            this.totalRFQData = [];
            this.delayedOMSData = [];
            this.deliveredOMSData = [];
            this.inProgressOMSData = [];

            this.totalQuotesReceivedData = [];
            this.totalQuotesUnderRevisionData = [];
            this.totalQuotesAcceptedData = [];
            // responseList[0].response is for RFQ chart
            responseList[0].response.monthlyData.sort((a: any, b: any) =>
              a.dateFormatted.localeCompare(b.dateFormatted),
            );

            responseList[0].response.monthlyData.forEach((item: any) => {
              this.monthRFQ.push(item.month);
              this.inProgressRFQData.push(item.quoteInProgressCount);
              this.acceptedRFQData.push(item.poAcceptedCount);
              this.returnedRFQData.push(item.poReturnedCount);
            });

            for (let i = 0; i < this.inProgressRFQData.length; i++) {
              this.totalRFQData.push(
                this.inProgressRFQData[i] +
                  this.acceptedRFQData[i] +
                  this.returnedRFQData[i],
              );
            }
            this.totalInProgressRFQ = responseList[0].response.countQuoteInProgress;
            this.totalAcceptedRFQ = responseList[0].response.countPoAccepted;
            this.totalReturnedRFQ = responseList[0].response.countPoReturned;
            this.totalRFQ =
              this.totalInProgressRFQ + this.totalAcceptedRFQ + this.totalReturnedRFQ;

            // responseList[1].response is for Profile chart
            this.profileCompleted = responseList[1].response.totalWeightage;

            //responseList[2] for OMS
            responseList[2].response.monthlyData.sort((a: any, b: any) =>
              a.dateFormatted.localeCompare(b.dateFormatted),
            );

            responseList[2].response.monthlyData.forEach((item: any) => {
              this.inProgressOMSData.push(item.inProgressCount);
              this.deliveredOMSData.push(item.deliveredCount);
              this.delayedOMSData.push(item.delayedCount);
            });

            for (let i = 0; i < this.inProgressOMSData.length; i++) {
              this.totalOMSData.push(
                this.inProgressOMSData[i] +
                  this.deliveredOMSData[i] +
                  this.delayedOMSData[i],
              );
            }
            this.totalInProgressOMS = responseList[2].response.inProgressCount;
            this.totaldeliveredOMS = responseList[2].response.deliveredCount;
            this.totaldelayedOMS = responseList[2].response.delayedCount;
            this.totalOMS =
              this.totalInProgressOMS + this.totaldeliveredOMS + this.totaldelayedOMS;
            //responseList[3] for Quotes Chart
            responseList[3].response.monthlyData.sort((a: any, b: any) =>
              a.dateFormatted.localeCompare(b.dateFormatted),
            );

            this.totalQuotesAccepted = responseList[3].response.countQuoteAccepted;
            // this.totalQuotesRejected = responseList[3].response.deliveredCount;
            this.totalQuotesReceived = responseList[3].response.countQuoteReceived;
            this.totalQuotesUnderRevision =
              responseList[3].response.countQuoteUnderRevision;

            responseList[3].response.monthlyData.forEach((item: any) => {
              this.totalQuotesAcceptedData.push(item.countQuoteAccepted);
              // this.totalQuotesRejectedData.push(item.deliveredCount);
              this.totalQuotesReceivedData.push(item.countQuoteReceived);
              this.totalQuotesUnderRevisionData.push(item.countQuoteUnderRevision);
            });

            this.initRFQBarChart();
            this.initProfilePieChart(this.profileCompleted);
            this.initQuotesBarChart();
            this.initOMSBarChart();
          },
          error: (e) => {
            if (e.error?.status?.error?.message) {
              this.toastr.error(e.error.status.error.message);
            }
          },
        });
    }
  }
  navigate(url: string) {
    this.router.navigateByUrl(url);
    // if (url.includes('shop')) {
    //   this.router.navigateByUrl(url);
    // } else if (!isEmpty(url) && !url.includes('shop')) {
    //   this.router.navigateByUrl(`customer/${url}`);
    // }
  }
  initRFQBarChart() {
    this.barChartOptions = {
      chart: {
        type: 'column',
        spacingTop: 10,
        spacingBottom: 10,
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: this.monthRFQ,
        crosshair: true,
        labels: {
          style: {
            fontSize: '10px',
            fontFamily: 'GraphikMedium',
          },
        },
      },
      yAxis: {
        title: {
          text: 'Values',
          style: {
            fontSize: '12px',
            fontFamily: 'graphiksemiBold',
          },
        },
      },
      legend: {
        symbolRadius: 0, // square legend symbol
        itemStyle: {
          fontSize: '11px',
          fontFamily: 'graphikregular',
        },
      },
      colors: ['#836AA0', '#E56469', '#E5B718', '#61C46E'],
      series: [
        {
          name: 'Total',
          type: 'column',
          data: this.totalRFQData,
        },
        {
          name: 'Returned',
          type: 'column',
          data: this.returnedRFQData,
        },
        {
          name: 'In Progress',
          type: 'column',
          data: this.inProgressRFQData,
        },

        // {
        //   name: 'Accepted',
        //   type: 'column',
        //   data: this.acceptedRFQData,
        // },
      ],
    };
  }
  initOMSBarChart() {
    this.barChartOMSOptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        symbolRadius: 0, // square legend symbol

        itemStyle: {
          fontSize: '11px',
          fontFamily: 'graphikregular',
        },
      },
      xAxis: {
        categories: this.monthRFQ,
        labels: {
          style: {
            fontSize: '10px',
            fontFamily: 'GraphikMedium',
          },
        },
      },
      yAxis: {
        title: {
          text: 'Values',
          style: {
            fontSize: '12px',
            fontFamily: 'graphiksemiBold',
          },
        },
      },
      colors: ['#836AA0', '#E5B718', '#61C46E'],
      series: [
        {
          name: 'Total',
          type: 'column',
          data: this.totalOMSData,
        },
        {
          name: 'In Progress',
          type: 'column',
          data: this.inProgressOMSData, // Adjusted values
        },

        {
          name: 'Delivered',
          type: 'column',
          data: this.deliveredOMSData, // Adjusted values
        },
      ],
    };
  }
  initQuotesBarChart() {
    this.barChartQuotesOptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        symbolRadius: 0, // square legend symbol

        itemStyle: {
          fontSize: '11px',
          fontFamily: 'graphikregular',
        },
      },
      xAxis: {
        categories: this.monthRFQ,
        labels: {
          style: {
            fontSize: '10px',
            fontFamily: 'GraphikMedium',
          },
        },
      },
      yAxis: {
        title: {
          text: 'Values',
          style: {
            fontSize: '12px',
            fontFamily: 'graphiksemiBold',
          },
        },
      },
      colors: ['#836AA0', '#E56469', '#61C46E'],
      // '#E5B718',
      series: [
        {
          name: 'Quotes Received',
          type: 'column',
          data: this.totalQuotesReceivedData,
        },
        {
          name: 'Quotes Accepted',
          type: 'column',
          data: this.totalQuotesAcceptedData, // Adjusted values
        },
        // {
        //   name: 'Quotes Rejected',
        //   type: 'column',
        //   data: this.inProgressOMSData, // Adjusted values
        // },

        {
          name: 'Quotes Under Revision',
          type: 'column',
          data: this.totalQuotesUnderRevisionData, // Adjusted values
        },
      ],
    };
  }
  initProfilePieChart(completed: any = 0) {
    var comp = Number(completed.toFixed(2));
    this.pieChartOptions = {
      chart: {
        type: 'gauge',
        plotBorderWidth: 0,
        plotShadow: false,
        height: '75%', // Adjust the height if necessary
      },

      title: {
        text: 'Profile Meter',
        style: {
          fontSize: '12px',
          fontFamily: 'graphikregular',
        },
      },

      pane: {
        startAngle: -90, // Start from -90 degrees for the top half
        endAngle: 90, // End at 90 degrees for the top half
      },

      yAxis: {
        min: 0,
        max: 100,
        tickPosition: 'inside',
        tickLength: 10,
        tickColor: '#ffffff',
        tickInterval: 20,
        lineWidth: 0,
        labels: {
          distance: -20, // Adjust this value to position labels inside
          style: {
            color: '#000',
            fontSize: '12px',
          },
        },
        plotBands: [
          {
            from: 0,
            to: 69,
            color: '#E5B718',
            innerRadius: '80%',
            outerRadius: '100%',
          },
          {
            from: 70,
            to: 89,
            color: '#61C46E', //orange
            innerRadius: '80%',
            outerRadius: '100%',
          },
          {
            from: 90,
            to: 100,
            color: '#298135', // Yellow
            innerRadius: '80%',
            outerRadius: '100%',
          },
        ],
      },

      series: [
        {
          type: 'gauge',
          name: 'Profile Completed:',
          data: [comp], // Current value of the gauge
          tooltip: {
            valueSuffix: ' %',
          },
          dataLabels: {
            y: -50, // Adjust label position
            formatter: function () {
              return `${this.y}%`; // Add the % symbol directly to the data label
            },
            style: {
              fontSize: '14px', // Adjust the font size if necessary
              color: '#000', // Adjust the color if necessary
            },
          },
          dial: {
            radius: '80%',
            backgroundColor: '#000000',
          },
        },
      ],
    };
  }
}
